import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Title } from './MemberSetting';
import { useSetting } from '../../shared/hooks/useApi/useSetting';
import { usePayment } from '../../shared/hooks/useApi/usePayment';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { popIn } from '../../shared/component/Animation';
import { BlackFullWidthBtn } from '../../shared/component/headless/button/BtnBody';
import { useAuth } from '../../shared/hooks/useApi/useAuth';
import ProductCard from './ProductCard';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import deleteIcon from '../../asset/icon/delete.png';
import { getModalMessage } from '../../shared/constants/modalMessages';
import { getBtnName } from '../../shared/constants/btnNames';
import { paperTextureModal } from '../../shared/component/paperTexture';
import HeadlessBtn from '../../shared/component/headless/button/HeadlessBtn';

const SubscriptionModal: React.FC = () => {
  const { user } = useAuth();
  const { setting } = useSetting();
  const { standardModal, isClosing, clearModal } = useModalStore();
  const { product, getProduct, createCheckout } = usePayment();

  useEffect(() => {
    if (product) return;
    getProduct();
  }, []);

  if (!setting || standardModal == null || !user || !product) return null;

  const handleMoveToSubscribe = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    await createCheckout();
  }

  const handleClose = () => {
    // esRef.current?.close();    // 즉시 해제
    clearModal();
  };

  return (
    <SubscriptionModalFrame
      onClick={(e) => e.stopPropagation()}
      $isClosing={isClosing}
    >
      <HeaderRow>
        <ModalTitle>{getModalMessage('SUBSCRIPTION_TITLE')}</ModalTitle>
        <UniversalIconBtn
          size="small"
          border={false}
          isTransparent
          hoverOpacity
          backgroundImg={deleteIcon}
          onClick={handleClose}
        />
      </HeaderRow>
      <SubscriptionComp>
        <ProductCard />
      </SubscriptionComp>
      <HeadlessBtn 
        value={getBtnName('MOVE_TO_SUBSCRIBE')} 
        handleClick={handleMoveToSubscribe} 
        StyledBtn={SubmitButton} />
    </SubscriptionModalFrame>
  );
}


export const SubscriptionModalFrame = styled.div<{ $isClosing: boolean }>`
  position: relative;
  padding: 30px 25px;
  width: fit-content;
  height: fit-content;
  
  opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
  transform: ${({ $isClosing }) => ($isClosing ? 'scale(0.8)' : 'scale(1)')};
  
  transition: all 0.3s ease-in;
  ${paperTextureModal}
  ${popIn}
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const ModalTitle = styled(Title)`
  margin-bottom: 0;
`;

const SubscriptionComp = styled.section`
  width: 480px;
  height: 100%;
  display: flex;
  overflow-x: hidden;
  transition: all 1.4s cubic-bezier(0.4, 0, 0.2, 1);
`;

const SubmitButton = styled(BlackFullWidthBtn)`
  width: 100%;
  margin: 10px 0px 20px 0;
`;

export default SubscriptionModal;